import React, { Suspense, useCallback, useMemo } from 'react';
import { ErrorBoundary } from '@splunk/dashboard-ui';
import { console } from '@splunk/dashboard-utils';
import { useMicrofrontendContext } from '@splunk/dashboard-context';
import { _ } from '@splunk/ui-utils/i18n';
import { ActionItem } from '../ActionItem';
import { ActionButton } from '../ActionButton';

const EmptyComponent = () => null;

export interface BaseAIAssistantButtonProps {
    title: string;
    onClick?: () => void;
}

export const BaseAIAssistantButton = ({
    title,
    onClick,
}: BaseAIAssistantButtonProps) => {
    const { AIIcon } = useMicrofrontendContext().microfrontendProxy ?? {};

    const handleError = useCallback((error: string) => {
        console.error(_('Error loading AI Assistant:'), error);
        return <EmptyComponent />;
    }, []);

    const icon = useMemo(() => {
        if (!AIIcon) {
            return null;
        }
        return (
            <Suspense key="ai-assistant" fallback={null}>
                <AIIcon title={null} />
            </Suspense>
        );
    }, [AIIcon]);

    if (!icon) {
        return null;
    }

    return (
        <ErrorBoundary render={handleError}>
            <ActionItem>
                <ActionButton
                    data-test="ai-assistant-button"
                    onClick={onClick}
                    icon={icon}
                    title={title}
                />
            </ActionItem>
        </ErrorBoundary>
    );
};
